module.exports = __webpack_public_path__ + "img/cover3.22d54c3a.png";